import ResourcingOutlookIndicators from './ResourcingOutlookIndicators';

export default ResourcingOutlookIndicators;
